// Charge la base commune
import './common.js'

// Contact Form
async function getJForm ($f) {
  import(/* webpackChunkName: "jobForm" */ './js/components/jobForm.js').then(() => {
    /* global Waypoint */
    Waypoint.refreshAll()
    $f.load(false)
  })
}

// actions principales
$(document).ready(function () {
  const $jf = $('form[name="jForm"]')
  $jf.load()
  getJForm($jf)

  // formulaire de contact
//  const $jf = $('form[name="jForm"]')
//  $jf.waypoint(function () {
//    $jf.load()
//    getJForm($jf)
//    this.destroy()
//  }, {
//    offset: '100%'
//  })
})
